import styled from 'styled-components';

import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { Flag } from '@xing-com/flag';
import { Link } from '@xing-com/link';
import {
  spaceM,
  spaceL,
  spaceXXS,
  spaceXS,
  spaceS,
  spaceXL,
} from '@xing-com/tokens';
import { Headline, Meta } from '@xing-com/typography';

const MemberCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const MemberFlag = styled(Flag)`
  margin-bottom: ${spaceXS};
`;

const MemberName = styled(Headline)`
  margin-bottom: ${spaceXXS};
  overflow: hidden;
  word-break: break-word;
  ${lineClamp(2)}
`;

const MemberOccupation = styled(Meta)`
  overflow: hidden;
  word-break: break-word;
  ${lineClamp(2)}
`;

const MemberInfo = styled(Link)`
  display: flex;
  flex-direction: row;
  gap: ${spaceM};
  margin-bottom: ${spaceM};

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const MemberAboutMe = styled.div<{ $hasSharedContacts: boolean }>`
  margin-bottom: ${spaceXL};
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${spaceS};
  overflow: hidden;
  max-height: ${({ $hasSharedContacts }) =>
    $hasSharedContacts ? '76px' : 'none'};
`;

const MemberSharedContacts = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spaceL};
`;

export const Styled = {
  MemberCard,
  MemberFlag,
  MemberName,
  MemberOccupation,
  MemberInfo,
  MemberAboutMe,
  MemberSharedContacts,
};
